<script>
    import { onMount, tick } from "svelte";
    import app from "@/store/app.js";
    import user from "@/store/user.js";
    import routes from "./routes";
    import { wait } from "@/assets/js/util";
    
    let Page;
    let history = {};
    let current = "";
    let mounted = false;

    $: push($app.url);
    async function push(path) {
        if (current == path || !mounted) return;
        await beforeRouteChange($app.url, current);
        const [pathPart, queryPart] = path.split("?");
        const url = convertToWild(pathPart);
        if (!routes[url]?.page) return push("/404");
        if ((path == current && Page) || guard(url)) return push("/permission-denied");
        const scroller = document.querySelector('[data-scroll-container]');
        const sx = scroller ? scroller.scrollLeft : window.scrollX;
        const sy = scroller ? scroller.scrollTop : window.scrollY;
        history[current] = { y: sy, x: sx };
        current = path;
        const module = await import(`../views/${routes[url]?.page}.svelte`);
        Page = module.default;
        await tick();
        const scroller2 = document.querySelector('[data-scroll-container]');
        const hx = history[path]?.x || 0;
        const hy = history[path]?.y || 0;
        if (scroller2) scroller2.scrollTo(hx, hy); else window.scrollTo(hx, hy);
        // Run a second restoration after layout/data settle to handle list re-render after edits
        await tick();
        await wait(0);
        const scroller3 = document.querySelector('[data-scroll-container]');
        if (scroller3) scroller3.scrollTo(hx, hy); else window.scrollTo(hx, hy);
        if (Page !== undefined) {
            const fullPath = queryPart ? `${pathPart}?${queryPart}` : pathPart;
            const currentFull = window.location.pathname + (window.location.search || "");
            if (currentFull !== fullPath) {
                window.history.pushState(null, null, fullPath);
            }
        }
        document.title = `${routes[url]?.name || "App"}`;
        hijackAnchors();
        observeAnimate();
    }

    function handleHover() {
        const url = convertToWild(this.pathname);
        const view = routes[url]?.page;
        if (view) return import(`../views/${view}.svelte`);
    }
    async function beforeRouteChange(to, from) {
        return;
    }
    function handleClick(e) {
        e.preventDefault();
        const fullUrl = this.pathname + this.search;
        pushURLToStore(fullUrl);
    }
    function guard(path) {
        return false;
    }
    function convertURL(str) {
        str = str.split("/").map((el) => (el.startsWith(":") ? "*" : el));
        return str.join("/");
    }
    function convertToWild(url) {
        for (let oldKey of Object.keys(routes)) {
            let ary1 = url.split("/");
            let ary2 = convertURL(oldKey).split("/");
            if (ary1.length !== ary2.length) continue;
            for (let x in ary1) {
                if (ary2[x] == "*") ary1[x] = "*";
            }
            if (JSON.stringify(ary1) !== JSON.stringify(ary2)) continue;
            return ary1.join("/");
        }
    }
    function convertToDynamicRoutes() {
        for (let oldKey of Object.keys(routes)) {
            let newKey = convertURL(oldKey);
            routes[newKey] = routes[oldKey];
            if (oldKey == newKey) continue;
            delete routes[oldKey];
        }
    }
    function observeAnchors() {
        const observer = new MutationObserver(hijackAnchors);
        const elementNode = document.getElementById("app");
        let options = { attributes: false, childList: true, subtree: true };
        observer.observe(elementNode, options);
    }
    function observeAnimate() {
        const observer = new IntersectionObserver(animate, { threshold: 0 });
        let classes = ".animate, .animate-left, .animate-right";
        const animation = document.querySelectorAll(classes);
        animation.forEach((el) => observer.observe(el));
    }
    function hijackAnchors() {
        const parsedUrl1 = new URL(window.location.origin);
        var els = document.getElementsByTagName("a");
        for (let a of els) {
            let parsedUrl2 = new URL(a.href || window.location.origin);
            let same = parsedUrl1.hostname === parsedUrl2.hostname;
            if (same) a.addEventListener("click", handleClick);
            if (same) a.addEventListener("mouseover", handleHover);
        }
    }
    function animate(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) entry.target.classList.add("scroll-animation");
        });
    }
    function pushURLToStore(url) {
        const fullUrl = url || window.location.pathname + window.location.search;
        $app.url = fullUrl;
    }

    onMount(() => {
        mounted = true;
        pushURLToStore();
        window.history.scrollRestoration = "manual";
        window.onpopstate = async () => pushURLToStore();
        convertToDynamicRoutes();
        observeAnimate();
        observeAnchors();
    });
</script>

<svelte:component this={Page} />